import { useState, useEffect } from 'react';

export default function useToken () {
  function getToken () {
    const tokenString = window.localStorage.getItem('token');
    const userToken = JSON.parse(tokenString);

    // Check if the token exists and is not expired
    if (userToken && userToken.expiresAt > new Date().getTime()) {
      return userToken?.data.accessToken;
    } else {
      // Remove the token if it is expired or not present
      window.localStorage.removeItem('token');
      return null;
    }
  }

  const [accessToken, setAccessToken] = useState(getToken());

  const saveToken = (userToken, expirationHours = 4) => {
    const expiresAt = new Date().getTime() + expirationHours * 60 * 60 * 1000;
    const tokenData = { data: userToken.data, expiresAt };

    window.localStorage.setItem('token', JSON.stringify(tokenData));
    setAccessToken(userToken);
  };

  useEffect(() => {
    // Check and remove expired token on component mount
    getToken();
  }, []);

  return {
    setAccessToken: saveToken,
    accessToken
  };
}
